// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DocumentSummariesPlugin {
   resultsConfig: any
   static initClass() {
      // @ts-expect-error TS(2339) FIXME: Property 'states' does not exist on type 'Document... Remove this comment to see the full error message
      this.prototype.states = ['new', 'update']
   }

   constructor(config: any) {
      this.invoke = this.invoke.bind(this)
      this.resultsConfig = config.data.results
   }

   invoke(data: any, feed: any) {
      const docs = data.search.documents || []
      const start = feed.position - 1

      if ((data.updateType === "documents") && (docs.length > 0) && (start === docs.length)) {
         feed.setEndOfResults()
         return
      }

      // add items
      const position = (data.search.query.page_number - 1) * this.resultsConfig.pageSize + 1
      if (!feed.items().find((item:any)=> item?.document?.index && item.document.index === position)) {
         docs.forEach((doc: any, index: any) => {
            if (typeof doc == 'object') { // ensure it is a document
               doc.index = start + index + 1
               const item = {
                  document: doc,
                  type: 'documentSummary'
               }
               return feed.addItem(item)
            }
         })
      }

      // set endOfResults after we add the final results to the feed
      if (data?.search?.query?.page_number && data.search.query.page_number >= feed.maxPages) {
         return feed.setEndOfResults({ maxLimit: true })
      }
   }
}
DocumentSummariesPlugin.initClass()

DocumentSummariesPlugin.$inject = ['configService']

angular.module('summonApp.resultsFeedPlugins')
   .service('documentSummariesPlugin', DocumentSummariesPlugin)
